import React from "react";
import I18n from "../../../i18n";
import { Metrics } from "../../../theme/";
import Chart from "../../chart/";
import GraphCard from "../GraphCard";
import DataPercentList from "../../list/DataPercentList";
import { MathUtil, isFunction, OrgUtil, isFillAlive } from "../../../util";
import { GraphDataMaker } from "../../../util/helper/graph";
import ReportPieChart from "./ReportPieChart";

function findCategoryIndex(category_name, data, item){
	const id = OrgUtil.getCategoryIdByName(category_name, item);
	return data.findIndex(d=>d.id === id);
}
const CategoryPieChart = ({
	category_name = "CATEGORY_NAME",
	category_id = undefined,
	onHeaderClick,
	chart_id, 
	data, previousData,
	height, 
	chartHeight,
	colorType,
	style, 
	showLegend = true, 
	showColor = true,
	isVertical = false, 
	short = false,
	showValue,
	onClick,
	onLegendClick
})=>{
	const catID = category_id ? category_id : OrgUtil.getIdOfCategoryName(category_name); 
	// console.log("cat chart: ",{category_id, category_name}," to cat id is: ",catID);
	const categorys = {
		[-1]:I18n.t("unassign")
	};
	for(const dp of OrgUtil.getChoicesOfCategoryID(catID)){
		categorys[dp.id] = dp.name;
	}
	const toLabel = (d)=>categorys[d.id];
	const toValue = (d)=>d.count;
	let acceptData = isFillAlive(data) ? data.map(ori=>({...ori,name:toLabel(ori)})) : [];
	const categorySum = MathUtil.sum(acceptData, d=>d.count);
	const renderCategoryData = GraphDataMaker.makeRenderDataOfArray(acceptData,toLabel, toValue);
	const renderPreviousCategoryData = previousData ? GraphDataMaker.makeRenderDataOfArray(previousData,
		toLabel, toValue) : [];
	return (<ReportPieChart style={style} 
		header={category_name} 
		onHeaderClick={onHeaderClick}
		data={renderCategoryData} 
		previousData={renderPreviousCategoryData}
		height={height}
		chartHeight={chartHeight} 
		colorType={colorType} 
		showLegend={showLegend} 
		showColor={showColor}
		isVertical={isVertical} 
		showValue={showValue}
		short={short} 
		onClick={isFunction(onClick) ? (name)=>{
			// const index = findCategoryIndex(category_name, acceptData, name);
			onClick(acceptData.find(target=>target.name === name));
		} : undefined}
		onLegendClick={onLegendClick}
	/>);
};
export default CategoryPieChart;


// WEBPACK FOOTER //
// ./src/components/report/generics/ReportCatgoryChart.js